import { render, staticRenderFns } from "./PayersAmountList.vue?vue&type=template&id=5cfa384c&scoped=true"
import script from "./PayersAmountList.vue?vue&type=script&lang=js"
export * from "./PayersAmountList.vue?vue&type=script&lang=js"
import style0 from "./PayersAmountList.vue?vue&type=style&index=0&id=5cfa384c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfa384c",
  null
  
)

export default component.exports